// Services/fetchActivateUser.js
import { USERS } from "../Constants/Endpoints";
import { ApiRequestInterceptor } from "./apiRequest";

export const fetchActivateUser = async (userId) => {
  // encodea SOLO el segmento del path
  const path = USERS.usersActivate.replace("{userId}", encodeURIComponent(userId));
  const resp = await ApiRequestInterceptor(path, "PATCH", null);

  if (resp.code === 200) {
    return { statusCode: 200, ...resp.data };
  }
  return {
    statusCode: resp.code || 500,
    message: resp.data?.message || "Error al activar usuario",
  };
};